import { render, staticRenderFns } from "./LanguageMenu.vue?vue&type=template&id=636b0e1b&"
import script from "./LanguageMenu.vue?vue&type=script&lang=ts&"
export * from "./LanguageMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports